export const STATUS_META = {
  assigned: { label: 'Assigned', className: 'bg-violet-50 text-violet-700 ring-violet-200' },
  in_progress: { label: 'In progress', className: 'bg-blue-50 text-blue-700 ring-blue-200' },
  waiting_on_memo: { label: 'Waiting on memo', className: 'bg-amber-50 text-amber-800 ring-amber-200' },
  ready_to_submit: { label: 'Ready to submit', className: 'bg-emerald-50 text-emerald-700 ring-emerald-200' },
  submitted: { label: 'Submitted', className: 'bg-slate-100 text-slate-700 ring-slate-200' },
  cancelled: { label: 'Cancelled', className: 'bg-slate-50 text-slate-500 ring-slate-200' },
  local: { label: 'Not yet synced', className: 'bg-orange-50 text-orange-700 ring-orange-200' },
};

export const OPEN_STATUSES = ['assigned', 'in_progress', 'waiting_on_memo', 'ready_to_submit'];

export const FORM_TYPE_LABEL = {
  'Initial Assessment': 'Initial Assessment',
  '12 Week Review': '12 Week Review',
};

export const FORM_TYPE_SHORT = {
  'Initial Assessment': 'IA',
  '12 Week Review': '12WR',
};

export function StatusBadge({ status }) {
  const meta = STATUS_META[status] || { label: status, className: 'bg-slate-50 text-slate-600 ring-slate-200' };
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${meta.className}`}>
      {meta.label}
    </span>
  );
}

export function formatDate(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
